// @ts-nocheck
import { Box, Flex } from "@chakra-ui/react";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import Navbar from "@/components/Common/Navbar";
import Sidebar from "@/components/Common/Sidebar";
import { isLoggedIn } from "@/hooks/useAuth";

export const Route = createFileRoute("/_layout")({
  component: Layout,
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({
        to: "/login",
      });
    }
  },
});

function Layout() {
  return (
    <Flex h="100vh" bg="bg.option1">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <Flex
        flex="1"
        direction="column"
        // border="1px solid"
        // borderColor="borders.muted"
        boxShadow="sm"
        borderRadius="16px"
        overflow="auto"
        m={4}
        bg="bg.option2"
      >
        {/* Navbar */}
        <Box borderBottom="2px solid" borderColor="borders.muted">
          <Navbar />
        </Box>

        <Flex flex="1" overflow="hidden" p="1">
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Layout;
